<template>
  <div id="menu-toggle" @click="$emit('toggle')">
    <div class="menu-toggle-inner">
      <span class="burger-bar top"></span>
      <span class="burger-bar middle"></span>
      <span class="burger-bar bottom"></span>
    </div>
  </div>
</template>

<script>
export default {
  name: 'MenuToggle',
};
</script>

<style lang="scss">
  @import "../scss/variables";

  #menu-toggle {
    $ease-time: 350ms;
    $toggle-time: 550ms;

    padding: 1rem 1.5rem;
    margin: 0;
    box-sizing: content-box;
    width: 28px;
    height: 21px;

    cursor: pointer;

    @media only screen and (min-width: $breakpoint-md) {
      padding: 1rem 2.5rem;
    }

    .menu-toggle-inner {
      width: 28px;
      height: 21px;

      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);

      .burger-bar {
        display: block;
        position: absolute;
        height: 3px;
        width: 28px;

        background-color: white;

        transition: background-color $ease-time ease, opacity $toggle-time ease,
        transform $toggle-time ease;

        &:first-child {
          margin-top: 0;
        }

        &:last-child {
          margin-bottom: 0;
        }

        &.top {
          top: 0;
        }

        &.middle {
          top: 9px;
        }

        &.bottom {
          top: 18px;
        }

        @media only screen and (min-width: 1200px) {
          height: 2px;
          width: 28px;

          &.middle {
            /*top: 6px;*/
          }

          &.bottom {
            /*top: 12px;*/
          }
        }
      }
    }

    &.dark {
      .burger-bar {
        background-color: black;
      }
    }
  }

  .menu-open #menu-toggle {
    .burger-bar {
      &.top {
        top: 9px;
        transform: rotate(45deg);
      }

      &.middle {
        opacity: 0;
      }

      &.bottom {
        top: 9px;
        transform: rotate(-45deg);
      }
    }
  }
</style>
